import { jsxs as r, Fragment as e, jsx as l } from "react/jsx-runtime";
const c = () => /* @__PURE__ */ r(e, { children: [
  /* @__PURE__ */ l(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.5 11.25C12.7051 11.25 11.25 12.7051 11.25 14.5C11.25 15.3443 11.572 16.1134 12.0998 16.6913C9.86444 17.548 8.25 19.5677 8.25 22C8.25 22.4142 8.58579 22.75 9 22.75H14.5H20C20.4142 22.75 20.75 22.4142 20.75 22C20.75 19.5677 19.1356 17.548 16.9002 16.6913C17.428 16.1134 17.75 15.3443 17.75 14.5C17.75 12.7051 16.2949 11.25 14.5 11.25Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ l(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.2582 5.75C8.25276 5.83263 8.25 5.91599 8.25 6V7C8.25 7.41421 8.58579 7.75 9 7.75H19C19.4142 7.75 19.75 7.41421 19.75 7V6C19.75 3.92893 18.0711 2.25 16 2.25H12C10.561 2.25 9.31127 3.06055 8.68252 4.25H8C5.37665 4.25 3.25 6.37665 3.25 9V22C3.25 22.4142 3.58579 22.75 4 22.75C4.41421 22.75 4.75 22.4142 4.75 22V9C4.75 7.20507 6.20507 5.75 8 5.75H8.2582Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ l("circle", { cx: "11", cy: "10", r: "1", fill: "currentColor" }),
  /* @__PURE__ */ l("circle", { cx: "14", cy: "9", r: "1", fill: "currentColor" }),
  /* @__PURE__ */ l("circle", { cx: "17", cy: "10", r: "1", fill: "currentColor" })
] });
export {
  c as default
};
